import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import { useNavigationContext } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import {
  FDEmphasisSurface, FDFacetLogo, FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('GuidedHouseholdReviewNavigation', (theme) => ({
  drawerPaper: {
    width: '90%',
    minWidth: 300,
    maxWidth: 350,
    padding: theme.spacing(4),
    display: 'flex',
    alignItems: 'flex-start',
    '& .FD-MuiIconButton-root': {
      padding: 0,
      width: 'unset',
      marginLeft: '-2%', // The MUI close icon has some extra spacing on its sides - let's remove it so that it can be aligned with the Facet logo
    },
  },
  background: {
    backgroundColor: theme.palette.facet.primaryBlue,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  facetLogo: {
    padding: theme.spacing(2, 0),
    '& > *': {
      height: '34px !important',
    },
  },
}));

const GuidedHouseholdReviewNavigation = ({ open }) => {
  const classes = useStyles();
  const { setOpen, setNavPortal } = useNavigationContext();

  const closeDrawer = () => setOpen(false);

  const setRef = useCallback((node) => {
    setNavPortal(node);
    return () => setNavPortal(null);
  }, []);

  return (
    <Drawer
      anchor="left"
      open={open}
      ModalProps={{ onBackdropClick: closeDrawer }}
      PaperProps={{ className: classNames(classes.drawerPaper, classes.background) }}
    >
      <FDEmphasisSurface width="100%" height="100%" flex={1}>{/* Adjusts FD to have the right color scheme */}
        <div className={classes.background}>
          <FDStack direction="column" spacing={1} flex={1} alignItems="flex-start">
            <FDSecondaryActionIconButton icon="close" onClick={closeDrawer} size="lg" />
            <div className={classes.facetLogo}>
              <FDFacetLogo size="lg" />
            </div>
            <div
              className={classes.content}
              ref={setRef}
            />
          </FDStack>
        </div>
      </FDEmphasisSurface>
    </Drawer>
  );
};

GuidedHouseholdReviewNavigation.propTypes = {
  open: PropTypes.bool,
};

export default GuidedHouseholdReviewNavigation;
